module.exports = __webpack_public_path__ + "img/error-dark.0c05b57e.svg";